import { withTranslation } from 'react-i18next';

export default ns => component =>
    withTranslation(ns, { withRef: true })(component);
